import React from "react";
import { AuthProvider } from "./AuthContext";
import { BRSRProvider } from "./BRSRContext";
import { GRIProvider } from "./GRIContext";

const StateProviders = ({ children }) => {
  return (
    <AuthProvider>
      <GRIProvider>
        <BRSRProvider>{children}</BRSRProvider>
      </GRIProvider>
    </AuthProvider>
  );
};

export default StateProviders;
